<div [ngClass]="'container ' + size">
  <app-pop-up-header [title]="title"></app-pop-up-header>

  <div class="body">
    <ng-content></ng-content>
  </div>

  <div class="popup-footer">
    <div class="text">
      <p>{{footerText}}</p>
    </div>
    <app-button class="button-footer" *ngIf="showCloseButton" [text]="closeBtnText" (buttonEvent)="_close()"
      [type]="showSaveButton ? 'secondary' : 'primary'"></app-button>
    <app-button class="button-footer" *ngIf="showSaveButton" [text]="saveBtnText" (buttonEvent)="_save()" type="primary"
      [disabled]="disabledButton">
    </app-button>
    <app-button class="button-footer" *ngIf="showEditButton" [text]="editBtnText" (buttonEvent)="_save()" type="primary"
      [disabled]="disabledButton">
    </app-button>
  </div>
</div>
